"use strict";

export default {
  async getSubscription({ commit }, payload) {
    const { api } = payload;

    try {
      const res = await api.get(`/subscriptions/detail`);
      commit("setSubscriptionDetail", res.data.data);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async createSubscription({ commit }, payload) {
    const { api } = payload;

    try {
      const res = await api.post(`/subscriptions/create`, {
        subscription_plan_id: 1,
        type: "polaroid",
        duration: 1,
      });
      commit("setSubscriptionDetail", [res.data.data]);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async updateSubscription(_, payload) {
    const { api, ...rest } = payload;

    try {
      const res = await api.patch(`/subscriptions/update`, {
        ...rest,
      });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async getSubscriptionPlan(_, payload) {
    const { api } = payload;

    try {
      const res = await api.get(`/subscriptions/detail-plan`);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },
};
